import { render, staticRenderFns } from "./ModalParticipantClient.vue?vue&type=template&id=5cd08d24&"
import script from "./ModalParticipantClient.vue?vue&type=script&lang=js&"
export * from "./ModalParticipantClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports